'use strict';

exports.getQueryString = function (k) {
  var search = window.location.search;
  if (!search) {
    return '';
  } else {
    search = search.substr(search.indexOf('?') + 1);
  }
  console.log(search);
  var searches = search.split('&');
  console.log(searches);
  for (var i = 0; i < searches.length; i++) {
    var items = searches[i].split('=');
    if (items.length !== 2) {
      continue
    }
    if (items[0] === k) {
      return items[1];
    }
  }
  return '';
};


// WEBPACK FOOTER //
// ./src/helper/urlHelper.js